import { Profile } from '../components/user/Login'
import { apiCall } from '../utils/api'

// También lo usa el interceptor para verificar si la sesión sigue viva
export const CURRENT_USER_URL = `${process.env.REACT_APP_PUBLIC_CORE_API}/users/current`

export async function getProfile(): Promise<Profile | null> {
   try {
      const result = await apiCall({
         url: CURRENT_USER_URL,
         method: 'GET',
      })

      return result.data
   } catch (err) {
      return null
   }
}

export async function sendConfirmation(memberId: string): Promise<void> {
   try {
      await apiCall({
         url: `${process.env.REACT_APP_PUBLIC_STAGE_API}/loyalty/v1/send-email/welcome/${memberId}`,
         method: 'POST',
      })
   } catch (err) {
      throw err
   }
}
export async function chnageStatusPartner(request: { memberId: string, externalId: number, note?: string }): Promise<void> {
   const { memberId, note, externalId } = request
   try {
      await apiCall({
         url: `${process.env.REACT_APP_PUBLIC_STAGE_API}/loyalty/v1/members/${memberId}/${note ? 'activate' : 'deactivate'}?externalId=${externalId}`,
         ...(note ? { data: { note } } : {}),
         method: 'PATCH',
      })
   } catch (err) {
      throw err
   }
}
export async function addProfilePMS(request: { id: string, data: any }): Promise<void> {
   const { id, data } = request
   try {
      await apiCall({
         url: `${process.env.REACT_APP_PUBLIC_STAGE_API}/loyalty/v1/members/${id}/pms-profiles`,
         data,
         method: 'POST',
      })
   } catch (err) {
      throw err
   }
}